import PropTypes from 'prop-types';

import React from 'react';
import QuestionAnswerModal from './QuestionAnswerModal';
import i18n from "lib/utility/i18n";
import { FAIcon } from 'reactifi';
import { orderBy, reject } from 'lodash';

export default class QuestionAnswersForm extends React.Component {
  static propTypes = {
    allowNewAnswer: PropTypes.bool,
    answers: PropTypes.array,
    editable: PropTypes.bool,
    question: PropTypes.shape({
      id: PropTypes.number
    })
  };

  static defaultProps = {
    accountQuestion: {},
    answers: [],
    editable: true,
    allowNewAnswer: true
  };

  constructor(props) {
    super(props);

    this.state = {
      answers: props.answers,
      showAnswerModal: false
    };

    this.showNewAnswerModal = this.showNewAnswerModal.bind(this);
    this.showUpdateAnswerModal = this.showUpdateAnswerModal.bind(this);
    this.saveAnswer = this.saveAnswer.bind(this);
  }

  editOptions(answer) {
    if (this.props.editable) {
      return (<div>
        <a
          data-action="edit-answer"
          data-object-id={answer.id}
          data-object-type="answers"
          href="#"
          onClick={this.showUpdateAnswerModal(answer)}
        >
          <FAIcon icon="pen" />
        </a>&nbsp;
        <a
          data-action="delete-answer"
          data-object-id={answer.id}
          data-object-type="answers"
          href="#"
          onClick={this.removeAnswer(answer)}
        >
          <FAIcon icon="trash" />
        </a>&nbsp;
        <a
          data-action="move-answer-up"
          data-object-id={answer.id}
          data-object-type="answers"
          href="#"
          onClick={this.handlePosition(answer, -1)}
        >
          <FAIcon icon="arrow-up-long" />
        </a>&nbsp;
        <a
          data-action="move-answer-down"
          data-object-id={answer.id}
          data-object-type="answers"
          href="#"
          onClick={this.handlePosition(answer, 1)}
        >
          <FAIcon icon="arrow-down-long" />
        </a>
      </div>)
    }
  }

  removeAnswer(answer) {
    return (event) => {
      event.preventDefault()
      this.setState({
        answers: reject(this.state.answers, an => {
          return an.answer_text === answer.answer_text && an.id === answer.id && an.description === answer.description
        })
      });
    }
  }

  handlePosition(answer, direction) {
    return (event) => {
      event.preventDefault()
      this.movePositions(answer, direction)
    }
  }

  movePositions(answer, direction) {
    let answersCopy = JSON.parse(JSON.stringify(this.state.answers));
    let movedir = (direction * -1)
    let newPosition = answer.position + direction
    if (newPosition > answersCopy.length || newPosition === 0) { return true }
    answersCopy.find((ans, i) => {
      // find by position since id won't be set for new answers
      if (ans.position === parseInt(answer.position)) {
        answersCopy[i].position = (answer.position + direction);
        // Take adjacent element with same position and update it accordingly
        let adjacent = answersCopy.find(item => (item.position === answersCopy[i].position) && (item.answer_text !== answersCopy[i].answer_text))
        if (adjacent) { adjacent.position = answersCopy[i].position + movedir; }
        this.setState({ answers: answersCopy })
        return true;
      }
    });
  }

  showNewAnswerModal(event) {
    event.preventDefault()
    this.refs.answerModal.show()
  }

  showUpdateAnswerModal(answer) {
    return (event) => {
      event.preventDefault()
      this.refs.answerModal.show(answer)
    }
  }

  handleSingleAnswer(answer, oldAnswer) {
    if (answer.answer_text === "")
      return alert(i18n.t("Answer text is required")) // eslint-disable-line no-alert

    if (oldAnswer) {
      oldAnswer.answer_text = answer.answer_text
      oldAnswer.description = answer.description
      oldAnswer.position = answer.position
    }
    else {
      this.state.answers.push(answer)
    }
  }

  saveAnswer(answer, oldAnswer) {
    if (answer.length === undefined) {
      this.handleSingleAnswer(answer, oldAnswer)
    } else if (answer.length > 0) {
      answer.map(ans => this.state.answers.push(ans))
    }
    this.forceUpdate()
    this.refs.answerModal.close()
  }

  render() {
    var ans = this.state.answers;
    ans = orderBy(ans, ['position'], ['asc']);
    let answers = ans && ans.map(answer => {
      return (
        <tr
          data-object-id={answer.id}
          data-object-type="answers"
          key={answer.id}
        >
          <td data-attribute="answer_text">{answer.answer_text}</td>
          <td>{this.editOptions(answer)}</td>
          <td data-attribute="position">{answer.position}</td>
        </tr>
      );
    });

    return (<div>
      {this.props.editable ? <input type="hidden" name="answers" value={JSON.stringify(this.state.answers)} /> : null}
      <table
        className="table table-hover"
        data-object-attribute="answers"
        data-object-id={this.props.question.id}
        data-object-type="account-questions"
      >
        <thead>
          <tr>
            <th>{i18n.t("Answer text")}</th>
            <th>{i18n.t("Actions")}</th>
            <th>{i18n.t("Position")}</th>
          </tr>
        </thead>
        <tbody>{answers}</tbody>
      </table>

      {this.props.allowNewAnswer ?
        <div>
          <div>&nbsp;</div>
          <a href="#" id="new_answer_button" className="btn btn-primary" onClick={this.showNewAnswerModal}>{i18n.t("New Answer")}</a>
        </div> : null}

      <QuestionAnswerModal
        answerCount={this.state.answers.length}
        onSave={this.saveAnswer}
        ref="answerModal" />
    </div>)
  }
}
